import {
} from 'constants/actions';


export const initialState = {
  isBooted: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
